import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { TwoFactorAuthorization } from '@app/entities/interfaces/ptrab/two-factor-authorization.interface';
import { BankData } from '@app/entities/models/ptrab/payslips/bank-data.model';
import { CarTransfer } from '@app/entities/models/ptrab/payslips/car-transfer.model';
import { DirectDebit } from '@app/entities/models/ptrab/payslips/direct-debit.model';
import { GarnishAmountPayslip, Garnishment } from '@app/entities/models/ptrab/payslips/garnishment.model';
import { Payslip } from '@app/entities/models/ptrab/payslips/payslip.model';

export interface PayslipstRepository {
  getPayslips(isEmployee: boolean): Observable<Payslip[]>;
  getGarnishmentList(): Observable<Garnishment[]>;
  getCarTransferList(): Observable<CarTransfer[]>;
  getDirectDebits(): Observable<DirectDebit[]>;
  arePayslipsAvailable(showToast: boolean): Promise<boolean | null>;
  calculateGarnishPayslip(company_code: string): Observable<GarnishAmountPayslip>;
  isDirectDebitCertificateAvaible(): Promise<boolean>;
  modifyDirectDebit(directDebit: DirectDebit, authorization: TwoFactorAuthorization): Observable<DirectDebit>;
  getBankDataName(iban: string): Observable<BankData>;
  currentStatus: any;
}

export const PAYSLIPS_REPOSITORY = new InjectionToken<PayslipstRepository>('PAYSLIPS_REPOSITORY');
